import React from 'react';
import PropTypes from 'prop-types';
import { Box, Toolbar } from '@mui/material';
import SocialIcons from '../../../sections/about/SocialIcons';
import LanguagePopover from './LanguagePopover';

const HeaderSocial = (props) => (
  <Toolbar
    className="card-bg"
    sx={{
      minHeight: '100% !important',
      px: { lg: 5, md: 1, sm: 1, xs: 1 },
      py: 0,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      borderBottom: '3px solid',
      borderImageSlice: 1,
      borderImageSource: 'linear-gradient(45deg, #f1d563, #976c2b)',
    }}
  >
    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
      <SocialIcons
        isHeader
        GridContainerProps={{
          sx: { justifyContent: 'flex-start', width: '100%', alignItems: 'center', gap: 1 },
        }}
        isFullRow={true}
        ImageStyles={{ maxWidth: 38, width: '100%' }}
      />
    </Box>

    <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
      <LanguagePopover />
    </Box>
  </Toolbar>
);

HeaderSocial.propTypes = {};

export default HeaderSocial;
